import { pagesText } from '../../constants/pagesText';
import { DEVICE_TAGS_QUERY_KEY } from '../../constants/query';
import { getCatalogInventoryOriginOptions } from 'src/utils/enums/catalogInventoryOrigin';
import { catalogInventoryIsSignedParamList } from 'src/pages/wdac-results/tabs/WdacCatalogInventory/constants';

const appsFilterValues = {
  contain: 'contain',
  notContain: 'notContain',
  executed: 'executed',
  installed: 'installed',
  yes: true,
  no: false,
  Start: 'Start',
  End: 'End',
  wdacImport: 'wdac_import',
  installationImport: 'installation_import',
};

const defaultFilterConditionLimit = 5;

export const blockedByDynamicCodeSecurityOptions = [
  {
    type: 'menu',
    options: [
      {
        label: pagesText.filters.filter.executed,
        value: appsFilterValues.executed,
      },
      {
        label: pagesText.filters.filter.installed,
        value: appsFilterValues.installed,
      },
    ],
    value: appsFilterValues.executed,
  },
  {
    type: 'menu',
    options: [
      {
        label: pagesText.filters.filter.yes,
        value: appsFilterValues.yes,
      },
      {
        label: pagesText.filters.filter.no,
        value: appsFilterValues.no,
      },
    ],
    value: '',
  },
];

export const sortFieldsNameMap = {
  environmentApplicationName: 'configMgrAppName',
  publisher: 'configMgrAppManufacturer',
  name: 'FilterDevice',
  // createdAt: 'DateFilter',
};

export const filtersConfigs = {
  softwareCenterName: {
    filtersCount: defaultFilterConditionLimit,
    canAddFilterCondition: true,
  },
  configMgrAppManufacturer: {
    filtersCount: defaultFilterConditionLimit,
    canAddFilterCondition: true,
  },
  configMgrAppName: {
    filtersCount: defaultFilterConditionLimit,
    canAddFilterCondition: true,
  },
  blockedByDynamicCodeSecurity: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: true,
  },
  trustedByISG: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: true,
  },
  source: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  FilterDevice: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  FilterWdac: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  PackagedAppStatuses: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  SignatureKind: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  FilterUnmatchedFiles: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  FilterUnmatchedFilesCrossDevices: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  PublisherName: {
    filtersCount: defaultFilterConditionLimit,
    canAddFilterCondition: true,
  },
  DeviceCountGreaterThan: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  wdacDeviceStatus: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  healthStatus: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  status: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  osVersion: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  osSku: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  osType: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  logTypes: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  logCollectorVersionSelect: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  TagName: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  CustomerEnvTagId: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  GlobalAppStatus: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  DateFilter: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  DateRange: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  Filter: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  IsSigned: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  lastWdacHeartbeatDateFilter: {
    filtersCount: 2,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  PackagedAppStatus: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  Tags: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
  FilterDeviceManagedInstallerRuleStatuses: {
    filtersCount: 1,
    shouldDisableLimitReached: true,
    canAddFilterCondition: false,
  },
};

export const defaultAppsFilters = {
  FilterAppResult: [
    [
      {
        name: 'FilterAppResult',
        type: '',
        value: '',
        order: '',
        label: 'FilterAppResult',
      },
    ],
  ],
  CustomerEnvAppIds: [
    [
      {
        name: 'CustomerEnvAppIds',
        value: '',
      },
    ],
  ],
  softwareCenterName: [
    [
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.contain,
            value: appsFilterValues.contain,
          },
          {
            label: pagesText.filters.filter.notContain,
            value: appsFilterValues.notContain,
          },
        ],
        value: '',
      },
      {
        type: 'input',
        value: '',
      },
    ],
  ],
  configMgrAppManufacturer: [
    [
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.contain,
            value: appsFilterValues.contain,
          },
          {
            label: pagesText.filters.filter.notContain,
            value: appsFilterValues.notContain,
          },
        ],
        value: '',
      },
      {
        type: 'input',
        value: '',
      },
    ],
  ],
  configMgrAppName: [
    [
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.contain,
            value: appsFilterValues.contain,
          },
          {
            label: pagesText.filters.filter.notContain,
            value: appsFilterValues.notContain,
          },
        ],
        value: '',
      },
      {
        type: 'input',
        value: '',
      },
    ],
  ],
  blockedByDynamicCodeSecurity: [
    [
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.executed,
            value: appsFilterValues.executed,
          },
          {
            label: pagesText.filters.filter.installed,
            value: appsFilterValues.installed,
          },
        ],
        value: '',
      },
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.yes,
            value: appsFilterValues.yes,
          },
          {
            label: pagesText.filters.filter.no,
            value: appsFilterValues.no,
          },
        ],
        value: '',
      },
    ],
  ],
  trustedByISG: [
    [
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.executed,
            value: appsFilterValues.executed,
          },
          {
            label: pagesText.filters.filter.installed,
            value: appsFilterValues.installed,
          },
        ],
        value: '',
      },
      {
        type: 'menu',
        options: [
          {
            label: pagesText.filters.filter.yes,
            value: appsFilterValues.yes,
          },
          {
            label: pagesText.filters.filter.no,
            value: appsFilterValues.no,
          },
        ],
        value: '',
      },
    ],
  ],
  DateFilter: [
    [
      {
        name: appsFilterValues.Start,
        type: 'date',
        value: '',
        label: 'From',
      },
    ],
    [
      {
        name: appsFilterValues.End,
        type: 'date',
        value: '',
        label: 'To',
      },
    ],
  ],
  source: [
    [
      {
        type: 'menu',
        name: 'source',
        value: '',
        options: [
          {
            label: 'WDAC Import',
            value: appsFilterValues.wdacImport,
          },
          {
            label: 'Installation Import',
            value: appsFilterValues.installationImport,
          },
        ],
      },
    ],
  ],
};

const devicelogTypesOptions = [
  {
    label: 'App X inventory',
    value: 'AppXInventory',
  },
  {
    label: 'App locker msi and script (ID 8040)',
    value: 'AppLockerMsiAndScript8040',
  },
  {
    label: 'App locker msi and script (ID 8039)',
    value: 'AppLockerMsiAndScript8039',
  },
  {
    label: 'Managed installers',
    value: 'ManagedInstallers',
  },
  {
    label: 'Security Catalogs',
    value: 'SecurityCatalogs',
  },
  {
    label: 'App locker msi and script (ID 8028)',
    value: 'AppLockerMsiAndScript8028',
  },
  {
    label: 'Win32 audit events (ID 3076)',
    value: 'CodeIntegrityOperational3076',
  },
  {
    label: 'Policy load events (ID 3099)',
    value: 'CodeIntegrityOperational3099',
  },
  {
    label: 'Win32 enforced events (ID 3077)',
    value: 'CodeIntegrityOperational3077',
  },
  {
    label: 'App locker msi and script (ID 8029)',
    value: 'AppLockerMsiAndScript8029',
  },
  {
    label: 'App control catalog inventory',
    value: 'AppControlCatalogInventory',
  },
];

export const defaultDeviceLogsFilters = {
  DateFilter: [
    [
      {
        name: 'Start',
        type: 'date',
        value: '',
        label: 'From',
        source: 'LogFilesFilter',
      },
    ],
    [
      {
        name: 'End',
        type: 'date',
        value: '',
        label: 'To',
        source: 'LogFilesFilter',
      },
    ],
  ],

  logTypes: [
    [
      {
        type: 'menu',
        name: 'logTypes',
        value: '',
        options: devicelogTypesOptions,
      },
    ],
  ],
};

export const defaultManagedInstallersFilters = {
  FilterManagedInstallersResult: [
    [
      {
        name: 'FilterManagedInstallersResult',
        type: '',
        value: '',
        order: '',
        label: 'FilterManagedInstallersResult',
      },
    ],
  ],
  Tags: [
    [
      {
        type: 'autocomplete',
        name: 'Tags',
        value: '',
        queryKey: DEVICE_TAGS_QUERY_KEY,
        itemName: 'tags',
      },
    ],
  ],
  FilterDeviceManagedInstallerRuleStatuses: [
    [
      {
        type: 'autocomplete',
        name: 'DeviceManagedInstallerRuleStatuses',
        value: '',
        itemName: 'tags',
      },
    ],
  ],
};

export const defaultManagedInstallersDevicesFilters = {
  FilterManagedInstallersAffectedDevices: [
    [
      {
        name: 'FilterManagedInstallersAffectedDevices',
        type: '',
        value: '',
        order: '',
        label: 'FilterManagedInstallersAffectedDevices',
      },
    ],
  ],
};
export const defaultManagedInstallersUnaffectedDevicesFilters = {
  FilterManagedInstallersUnaffectedDevices: [
    [
      {
        name: 'FilterManagedInstallersUnaffectedDevices',
        type: '',
        value: '',
        order: '',
        label: 'FilterManagedInstallersUnaffectedDevices',
      },
    ],
  ],
};

export const defaultCatalogInventoryFilters = {
  FilterCatalogInventoryResult: [
    [
      {
        name: 'FilterCatalogInventoryResult',
        type: '',
        value: '',
        order: '',
        label: 'FilterCatalogInventoryResult',
      },
    ],
  ],
  Tags: [
    [
      {
        type: 'autocomplete',
        name: 'Tags',
        value: '',
        queryKey: DEVICE_TAGS_QUERY_KEY,
        itemName: 'tags',
      },
    ],
  ],
  Filter: [
    [
      {
        type: 'menu',
        name: 'Origins',
        value: '',
        options: getCatalogInventoryOriginOptions(),
      },
    ],
  ],
  IsSigned: [
    [
      {
        name: 'IsSigned',
        value: '',
        options: catalogInventoryIsSignedParamList,
      },
    ],
  ],
};
export const defaultScriptExecutionFilters = {
  FilterScriptExecutionResult: [
    [
      {
        name: 'FilterScriptExecutionResult',
        type: '',
        value: '',
        order: '',
        label: 'FilterScriptExecutionResult',
      },
    ],
  ],
  DateRange: [
    [
      {
        name: appsFilterValues.Start,
        type: 'date',
        value: '',
        label: 'From',
      },
    ],
    [
      {
        name: appsFilterValues.End,
        type: 'date',
        value: '',
        label: 'To',
      },
    ],
  ],
  Filter: [
    [
      {
        type: 'menu',
        name: 'UserWriteable',
        value: '',
        options: [
          {
            label: 'Yes',
            value: 'true',
          },
          {
            label: 'No',
            value: 'false',
          },
        ],
      },
    ],
  ],
};

export const defaultScriptExecutionDevicesFilters = {
  FilterScriptExecutionAffectedDevices: [
    [
      {
        name: 'FilterScriptExecutionAffectedDevices',
        type: '',
        value: '',
        order: '',
        label: 'FilterScriptExecutionAffectedDevices',
      },
    ],
  ],
};
export const defaultPackagedAppsFilters = {
  FilterPackagedAppResult: [
    [
      {
        name: 'FilterPackagedAppResult',
        type: '',
        value: '',
        order: '',
        label: 'FilterPackagedAppResult',
      },
    ],
  ],
  PackagedAppStatuses: [
    [
      {
        type: 'autocomplete',
        name: 'PackagedAppStatuses',
        value: '',
        itemName: 'tags',
      },
    ],
  ],
  Tags: [
    [
      {
        type: 'autocomplete',
        name: 'Tags',
        value: '',
        queryKey: DEVICE_TAGS_QUERY_KEY,
        itemName: 'tags',
      },
    ],
  ],
  SignatureKind: [
    [
      {
        type: 'menu',
        name: 'SignatureKind',
        value: '',
      },
    ],
  ],
};

export const defaultUnmatchedFilesCrossDevicesFilters = {
  FilterUnmatchedFilesCrossDevices: [
    [
      {
        name: 'FilterUnmatchedFilesCrossDevices',
        type: '',
        value: '',
        order: '',
        label: 'FilterUnmatchedFilesCrossDevices',
      },
    ],
  ],
  PublisherName: [
    [
      {
        type: 'input',
        name: 'PublisherName',
        value: '',
      },
    ],
  ],
  DeviceCountGreaterThan: [
    [
      {
        type: 'number',
        name: 'DeviceCountGreaterThan',
        value: '',
      },
    ],
  ],
};

export const sidebarList = [
  {
    title: 'Public Application Name',
    name: 'softwareCenterName',
  },
  {
    title: 'publisher',
    name: 'configMgrAppManufacturer',
  },
  {
    title: 'Internal Application Name',
    name: 'configMgrAppName',
  },
  {
    title: pagesText.filters.blockedByDynamicCodeSecurity,
    name: 'blockedByDynamicCodeSecurity',
  },
  {
    title: pagesText.filters.trustedByISG,
    name: 'trustedByISG',
  },
  {
    title: pagesText.filters.dateFilter,
    name: 'DateFilter',
  },
  {
    title: 'Source',
    name: 'source',
  },
];
